import { useState } from "react";
import { ToolsShell, TOOLS_ACCENT } from "./ToolsShell.jsx";
import { CONVERSIONS, convert, convertTemperature, round } from "./convertcore.js";

const CATS = [
  ["length", "Length"],
  ["mass", "Mass"],
  ["volume", "Volume"],
  ["speed", "Speed"],
  ["area", "Area"],
  ["dataStorage", "Data"],
  ["temperature", "Temperature"],
];
const TEMP_UNITS = ["celsius", "fahrenheit", "kelvin"];
const labelize = (u) =>
  u.replace(/([A-Z])/g, " $1").replace(/U S/g, " (US)").replace(/^./, (c) => c.toUpperCase()).trim();

export default function Converter() {
  const [cat, setCat] = useState("length");
  const isTemp = cat === "temperature";
  const units = isTemp ? TEMP_UNITS : Object.keys(CONVERSIONS[cat].units);
  const [from, setFrom] = useState(units[0]);
  const [to, setTo] = useState(units[1]);
  const [val, setVal] = useState("1");

  const pickCat = (c) => {
    const u = c === "temperature" ? TEMP_UNITS : Object.keys(CONVERSIONS[c].units);
    setCat(c);
    setFrom(u[0]);
    setTo(u[1] || u[0]);
  };

  const v = parseFloat(val);
  let out = null;
  if (!isNaN(v)) {
    const r = isTemp ? convertTemperature(v, from, to) : convert(cat, v, from, to);
    out = r.ok ? round(r.result, 8) : r.error;
  }

  const sel = {
    width: "100%",
    background: "#13141F",
    border: "1px solid #262839",
    borderRadius: 10,
    color: "#E8E9F3",
    fontSize: 15,
    padding: "12px 14px",
    boxSizing: "border-box",
  };

  return (
    <ToolsShell title="Unit Converter">
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 16 }}>
        {CATS.map(([c, label]) => (
          <button
            key={c}
            onClick={() => pickCat(c)}
            style={{ background: cat === c ? TOOLS_ACCENT : "#1C1E2E", color: cat === c ? "#1A0604" : "#9A9DBE", border: "none", borderRadius: 8, padding: "8px 12px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
          >
            {label}
          </button>
        ))}
      </div>

      <label style={{ fontSize: 13, color: "#9A9DBE", display: "block", marginBottom: 6 }}>Value</label>
      <input value={val} onChange={(e) => setVal(e.target.value)} inputMode="decimal" style={{ ...sel, marginBottom: 14 }} />

      <label style={{ fontSize: 13, color: "#9A9DBE", display: "block", marginBottom: 6 }}>From</label>
      <select value={from} onChange={(e) => setFrom(e.target.value)} style={{ ...sel, marginBottom: 14 }}>
        {units.map((u) => <option key={u} value={u}>{labelize(u)}</option>)}
      </select>

      <label style={{ fontSize: 13, color: "#9A9DBE", display: "block", marginBottom: 6 }}>To</label>
      <select value={to} onChange={(e) => setTo(e.target.value)} style={{ ...sel, marginBottom: 8 }}>
        {units.map((u) => <option key={u} value={u}>{labelize(u)}</option>)}
      </select>

      <div style={{ marginTop: 18, background: "#13141F", border: `1px solid ${TOOLS_ACCENT}33`, borderRadius: 12, padding: "18px 20px" }}>
        {out === null ? (
          <span style={{ color: "#9A9DBE" }}>Enter a number</span>
        ) : typeof out === "string" ? (
          <span style={{ color: "#F8716A" }}>{out}</span>
        ) : (
          <div>
            <div style={{ fontSize: 14, color: "#9A9DBE" }}>{val} {labelize(from)} =</div>
            <div style={{ fontSize: 24, fontWeight: 700, color: TOOLS_ACCENT, marginTop: 4 }}>{out} {labelize(to)}</div>
          </div>
        )}
      </div>
    </ToolsShell>
  );
}

